import {
  parseTranslations,
  CommonTranslations,
  Login,
  Sites
} from '@pdrj/pmi-iqos-shared-react'
import { IqosphereApiManager } from '@iqosphere-common/services'
import LoginTranslations from './login.json'

Login.componentTranslations = {
  ...LoginTranslations,
  ...CommonTranslations
}

Login.componentDefaultProps = {
  ...Login.componentDefaultProps,
  translations: {
    ...parseTranslations(Login.componentTranslations, true)
  },
  site: Sites.iqosphere
}

Login.onLoginSuccessAdditionalAction = async () => {
  const api = new IqosphereApiManager()
  // await api.iqosphereAuth.getPosition(true)
  try {
    await api.iqosphereProfile.getAvatarProfile()
    window.dispatchEvent(new window.CustomEvent('avatarCookieUpdated'))
  } catch (ex) {}
}

export default Login
